








































































import {Component, Prop, Vue} from 'vue-property-decorator'
import BtnDefault from "@/components/UI/BtnDefault.vue"
import {namespace} from 'vuex-class'
import Router from "@/router";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

const profile = namespace('profile')

@Component({
  name: 'FilledSurveyList',
  components: {ErrorFetchingData, BtnDefault}
})

export default class FilledSurveyList extends Vue {
  @Prop({type: Array, default: () => []}) protected surveysFilled!: object[]
  @Prop({
    type: Object, default: () => {
    }
  }) protected totalSurveys!: object
  @Prop({type: Boolean, default: false}) protected loading!: boolean
  @Prop({type: Boolean, default: false}) protected error!: boolean

  @profile.Getter('plan') protected plan!: string

  limit:number = 35

  mounted() {
    console.log(this.totalSurveys)
  }

  get total() {
    if (this.plan == 'pro') return this.totalSurveys
    else return {filledAllSurveys: 1, shardsWithFilledSurveys: 1, filedSurveysToday: 1}
  }

  get surveys() {
    if (this.plan == 'pro') return this.surveysFilled
    else return [{
      "surveyTitle": "Your survey with Pro plan",
      "count": 0,
      "countToday": 0
    }, {
      "surveyTitle": "Your survey with Pro plan",
      "count": 0,
      "countToday": 0
    }, {
      "surveyTitle": "Your survey with Pro plan",
      "count": 0,
      "countToday": 0
    }, {
      "surveyTitle": "Your survey with Pro plan",
      "count": 0,
      "countToday": 0
    }, {"surveyTitle": "Your survey with Pro plan", "count": 0, "countToday": 0}]
  }

  toSurveys() {
    Router.push({path: 'survey'})
  }

}
